import { InjectionToken } from '@angular/core';
import { Page } from '../../../shared/models/page';
import { ObservableResult } from '../../../shared/store';
import { Moment } from '../../folio/models';
import { EnrichedTask } from '../models/user-task.model';

export const MY_HUB_DATA_SERVICE = new InjectionToken<MyHubDataService>('[MyHub] MyHubDataService');

export interface MyHubDataService {
  getCommunityMoments(page: number, size: number): ObservableResult<Page<Moment>>;

  getTasks(page: number, size: number): ObservableResult<Page<EnrichedTask>>;
}
